import { render, staticRenderFns } from "./my.vue?vue&type=template&id=4ff2d402&scoped=true&"
import script from "./my.vue?vue&type=script&lang=js&"
export * from "./my.vue?vue&type=script&lang=js&"
import style0 from "./my.vue?vue&type=style&index=0&id=4ff2d402&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff2d402",
  null
  
)

export default component.exports